import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'reactstrap';
import { change, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { isRequired } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';
import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';

export const ChangeConsigneeCustomerForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
  parcel,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <CustomerInputGroup
      label="Nuevo Consignado"
      labelRequired
      name="consigneeCustomerId"
      form="ChangeConsigneeCustomerForm"
      validate={[isRequired]}
      showDetails
      isClearable
    />

    {parcel.secondaryConsigneeCustomer && (
      <CustomerInputGroup
        label="Nuevo Consignado Secundario"
        name="secondaryConsigneeCustomerId"
        form="ChangeConsigneeCustomerForm"
        showDetails
        isClearable
      />
    )}

    <FormFooter
      saveButtonColor="warning"
      saveButtonIcon="fa fa-user"
      saveButtonText="Cambiar Datos"
    >
      <Button color="primary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

ChangeConsigneeCustomerForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  parcel: PropTypes.instanceOf(Object).isRequired,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'ChangeConsigneeCustomerForm',
})(ChangeConsigneeCustomerForm);

export default connect(null, mapDispatchToProps)(formComponent);
